import React from 'react';
import './BetterOptions.css';
import { trackAffiliateLinkClicked } from '../utils/analytics';

const OPTIONS = {
  risky: {
    heading: 'You may want to consider safer options:',
    cards: [
      {
        id: 'personal-loan',
        icon: '💳',
        title: 'Compare Personal Loan Rates',
        description: 'A lower-rate personal loan could replace high-interest financing and cut your monthly payment.',
        cta: 'Compare rates',
        href: '#'
      },
      {
        id: 'lower-interest',
        icon: '📉',
        title: 'Find Lower Interest Rates',
        description: 'Shopping multiple lenders before committing can save hundreds over the life of your loan.',
        cta: 'See options',
        href: '#'
      },
      {
        id: 'high-yield-savings',
        icon: '🏦',
        title: 'Build Your Emergency Fund First',
        description: 'A high-yield savings account earns 4–5% APY while you save up for a stronger down payment.',
        cta: 'Explore savings accounts',
        href: '#'
      }
    ]
  },
  stretch: {
    heading: 'Lower your monthly payment:',
    cards: [
      {
        id: 'personal-loan',
        icon: '💳',
        title: 'Compare Personal Loan Rates',
        description: 'Refinancing or shopping lenders could reduce your rate and free up monthly cash flow.',
        cta: 'Compare rates',
        href: '#'
      },
      {
        id: 'refinancing',
        icon: '🔄',
        title: 'Explore Refinancing Options',
        description: 'If you already have a loan, refinancing at a lower rate can meaningfully reduce what you pay each month.',
        cta: 'See refinancing options',
        href: '#'
      }
    ]
  },
  comfortable: {
    heading: 'Want to optimize this purchase?',
    cards: [
      {
        id: 'protect-savings',
        icon: '🛡️',
        title: 'Protect Your Savings',
        description: 'Keep your emergency fund working with a high-yield savings account that earns competitive interest.',
        cta: 'Compare savings accounts',
        href: '#'
      },
      {
        id: 'invest-difference',
        icon: '📈',
        title: 'Invest the Difference',
        description: "If you're paying cash, the money not tied up in installments could go into a low-cost index fund.",
        cta: 'Explore investment options',
        href: '#'
      }
    ]
  }
};

function BetterOptions({ verdict }) {
  const key =
    verdict === 'Risky' || verdict === 'Not advised'
      ? 'risky'
      : verdict === 'Stretch'
      ? 'stretch'
      : 'comfortable';

  const { heading, cards } = OPTIONS[key];

  const handleClick = (card) => {
    trackAffiliateLinkClicked({ linkType: card.id, verdict });
  };

  return (
    <div id="better-options" className="card better-options-card">
      <h3>🔍 {heading}</h3>
      <div className="better-options-grid">
        {cards.map((card) => (
          <a
            key={card.id}
            href={card.href}
            className="affiliate-card"
            target="_blank"
            rel="noopener noreferrer sponsored"
            onClick={() => handleClick(card)}
          >
            <span className="affiliate-icon">{card.icon}</span>
            <div className="affiliate-content">
              <strong>{card.title}</strong>
              <p>{card.description}</p>
              <span className="affiliate-cta">{card.cta} →</span>
            </div>
          </a>
        ))}
      </div>
      <p className="affiliate-disclosure">
        * Some links above are affiliate links. We may earn a commission if you click through and sign up — at no extra cost to you. This helps keep the calculator free.
      </p>
    </div>
  );
}

export default BetterOptions;
